import { Injectable } from '@angular/core';
import {
	MatSnackBar,
	MatSnackBarConfig,
} from '@angular/material/snack-bar';
import { AppToastComponent } from '@app/components/shared/app-toast.component';

import { ToastType } from 'src/app/constants/toast-type';
import { IToast } from 'src/app/models/toast';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	constructor(private snackBar: MatSnackBar) { }

	public buildToastMessage(
		p_toastType: ToastType,
		p_header: string,
		p_message: string
	): void {
		const l_Toast: IToast = {
			header: p_header ? p_header : p_toastType,
			description: p_message,
			options: {
				timeOut: 10000,
				positionClass: 'toast-top-right',
			},
		};

		this.openToast(l_Toast, p_toastType);
	}

	public clearToasts(): void {
		this.snackBar.dismiss();
	}

	private openToast(params: IToast, toastType: ToastType): void {
		const type = String(toastType).toLowerCase();

		const config: MatSnackBarConfig = {
			duration: params.options?.timeOut ?? 10000,
			horizontalPosition: 'right',
			verticalPosition: 'top',
			panelClass: [
				'app-toast',
				`app-toast-${type}`,
			],
			data: {
				header: params.header,
				description: params.description,
				type,
			},
		};

		this.snackBar.openFromComponent(AppToastComponent, config);
	}
}